import { createReducer } from 'src/utils/create-reducer';

import {
  LoadPullRequests,
  SetHasDeploymentEnvironments,
  UnloadPullRequests,
} from '../actions';
import { PullRequestList } from '../types';

export const pullRequestListInitialState: PullRequestList = {
  listItems: [],
  nextUrl: null,
  isLoading: false,
  isError: false,
  exception: undefined,
  isPreRequestState: true,
  reloadUrl: null,
  size: 0,
  pagelen: 0,
  hasDeploymentEnvironments: true,
};

export const pullRequestListDataReducer = createReducer(
  pullRequestListInitialState,
  {
    [LoadPullRequests.REQUEST](state, action) {
      const reloadUrl = action.meta && action.meta.url ? action.meta.url : null;

      return {
        ...state,
        isLoading: true,
        isError: false,
        exception: undefined,
        isPreRequestState: false,
        reloadUrl,
        hasDeploymentEnvironments: true,
      };
    },

    [LoadPullRequests.ERROR](state, action) {
      return {
        ...state,
        isLoading: false,
        isError: true,
        exception: action.meta?.exception,
      };
    },

    [LoadPullRequests.SUCCESS](state, action) {
      const { values, next, size, pagelen } = action.payload.result;

      return {
        ...state,
        listItems: [...values],
        nextUrl: next,
        isLoading: false,
        isError: false,
        exception: undefined,
        pagelen,
        size,
      };
    },

    [SetHasDeploymentEnvironments](state, action) {
      return {
        ...state,
        hasDeploymentEnvironments: action.payload.value,
      };
    },

    [UnloadPullRequests]() {
      return pullRequestListInitialState;
    },
  }
);
